<template>
  <div id="app">
    <popupTraining
      @closePopup="closePopup"
      @updateit="updateit"
      :state="state"
      :modelTrainPollutant="currentOptions"
      v-if="content === 'showpopup'"
      style="background: yellow"
    ></popupTraining>
    <div class="row mt-4 justify-content-center pl-2" style="width: 100vw">
      <div class="col-sm-10 col-md-10 p-0">
        <div class="d-flex justify-content-between">
          <h2 class="my-4 ml-3">History</h2>
          <button @click="triggerEvent(2)" class="my-4 pr-3">Analyze New Dataset</button>
        </div>
        <div class="table-responsive mb-4 pl-3">
          <table class="table table-bordered table-hover mb-0">
            <thead>
              <tr class="tableHeading">
                <th style="width: 5%">Project Name</th>
                <th style="width: 20%">Report Status</th>
                <th style="width: 25%">Graph Status</th>
              </tr>
            </thead>
            <tbody v-if="allVisulaData.length !== 0">
              <tr v-for="(rows, i) in onlyValidIRows" :key="i">
                <td>{{rows['project_name']}}</td>
                <td>
                  <!-- {{rows['report'] == 'Error'}} -->
                  <div v-if="rows['report'].status == 'Error'">
                    <span>
                      <i
                        @mouseover="mousOverPopup(rows['_id'])"
                        data-original-title=""
                        title=""
                        data-placement="bottom" 
                        :data-toggle="rows['_id']+'report'"
                        :data-content="rows['report'].message"
                        class="fas fa-exclamation-circle mr-2 cursor-pointer"
                        style="color: red;"
                      ></i>
                      <span
                        class="cursor-pointer"
                        @click="routeToreport(rows['_id'])"
                      >See Partial Report</span>
                    </span>
                  </div>
                  <div v-if="rows['report'].status == 'none'">
                    <span
                      class="cursor-pointer generateReport"
                      @click="generateReport(rows)"
                    >Generate Report</span>
                  </div>
                  <div v-else-if="rows['report'].status == 'Started'">
                    <i class="fas fa-spinner fa-pulse"></i>
                    Going On
                  </div>
                  <div v-else-if="rows['report'].status == 'Finished'">
                    <span class="cursor-pointer" @click="routeToreport(rows['_id'])">
                      <i class="green far fa-check-circle mr-1"></i>See Report
                    </span>
                  </div>
                </td>
                <td>
                  <div v-if="rows['graph'].status == 'Error'">
                    <span>
                      <i
                        @mouseover="mousOverPopupGraph(rows['_id'])"
                        data-original-title=""
                        title=""
                        data-placement="top" 
                        :data-toggle="rows['_id']+'graph'"
                        :data-content="rows['graph'].message"
                        class="fas fa-exclamation-circle mr-2 cursor-pointer"
                        style="color: red;"
                      ></i>
                      <span
                        class="cursor-pointer"
                        @click="routeTograph(rows['_id'])"
                      >See Partial Graph Report</span>
                    </span>
                  </div>
                  <div v-if="rows['graph'].status == 'none'">
                    <span
                      class="cursor-pointer generateGraphReport"
                      @click="generateGraphReport(rows)"
                    >Generate Graph Report</span>
                  </div>
                  <div v-else-if="rows['graph'].status == 'Started'">
                    <i class="fas fa-spinner fa-pulse"></i>
                    Going On
                  </div>
                  <div v-else-if="rows['graph'].status == 'Finished'">
                    <span class="cursor-pointer" @click="routeTograph(rows['_id'])">
                      <i class="green far fa-check-circle mr-1"></i>See Graph Report
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="pt-5 pb-5 text-center" colspan="6">
                  you have zero Visualization report....
                  <span
                    style="color: blue; text-decoration: underline"
                    class="cursor-pointer changePassword"
                    @click="triggerEvent(2)"
                  >Start using</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiCall } from "@/utils/api";
// import $ from 'jquery';

export default {
  name: "VisualizeTable",
  props: {},
  components: {},
  data() {
    return {
      allVisulaData: [],
      currentOptions: [],
      state: "",
      content: "",
      lastTraining: []
    };
  },
  watch: {},
  mounted() {
    this.getAllData();
    setInterval(() => {
      this.getAllData();
    }, 3000);
  },
  computed: {
    onlyValidIRows() {
      return this.allVisulaData.filter((data)=> {
        return data.raw_file_url
      })
    }
  },
  methods: {
    mousOverPopupGraph(id) {
      /* eslint-disable */
      // $(`.popover-header`).remove();
      $(`[data-toggle=${id}graph]`).popover({
        title: "",
        trigger: "hover",
      });
    },
    mousOverPopup(id) {
      /* eslint-disable */
      // $(`.popover-header`).remove();
      $(`[data-toggle=${id}report]`).popover({
        title: "",
        trigger: "hover",
      });
    },
    routeTograph(id) {
      this.$router.push(`/graph/${id}`);
    },
    routeToreport(id) {
      this.$router.push(`/report/${id}`);
    },
    triggerEvent(count) {
      this.$emit("updateIt", count);
    },
    generateGraphReport(row) {
      const url = `visual_ml/graph/${row["_id"]}`;
      const body = {
        bucket_name: row.bucket_name,
        filename: `${row.userId}/${row.raw_file_name}`,
        project_name: row.project_name,
        numerical: row.numerical,
        categorical: row.categorical,
        datetime: row.datetime,
        visualId: row._id,
        userId: row.userId,
        timeInterval: row.timeInterval
      };
      // console.log('body is here', body)
      apiCall({ url, data: body, method: "post" })
        .then(() => {
          this.$toasted.show("request submitted", { duration: 1000 });
        })
        .catch(err => {
          console.log("error is here", err);
        });
    },
    generateReport(row) {
      const url = `visual_ml/report/${row["_id"]}`;
      const body = {
        bucket_name: row.bucket_name,
        filename: `${row.userId}/${row.raw_file_name}`,
        project_name: row.project_name,
        numerical: row.numerical,
        categorical: row.categorical,
        datetime: row.datetime,
        visualId: row._id,
        userId: row.userId
      };
      apiCall({ url, data: body, method: "post" })
        .then(() => {
          this.$toasted.show("request submitted", { duration: 1000 });
        })
        .catch(err => {
          console.log("error is here", err);
        });
    },
    getAllData() {
      const url = `visual_ml`;
      apiCall({ url, method: "get" })
        .then(resp => {
          this.allVisulaData = resp.data;
        })
        .catch(err => {
          console.log("error is here", err);
        });
    }
  }
};
</script>

<style scoped>
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
button {
  width: 13rem;
  height: 3rem;
  border: none;
  color: white;
  background: cadetblue;
  border-radius: 20px;
}
.green {
  color: green;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.4s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  min-height: 35px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.2s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
}
.cursor-pointer {
  cursor: pointer;
}
.logoutFont {
  color: white;
  font-size: 1rem;
  font-weight: bolder;
}
</style>
